import { FormLabelProps } from "@mui/material";
import React from "react";
import MuiFormLabel from "@mui/material/FormLabel";
import { colors, fontSizes } from "../theme";
interface OwnFormLabelProps extends FormLabelProps {
  children: React.ReactNode;
  className?: string;
  includeOptionalText?: boolean;
}

const FormLabel: React.FC<OwnFormLabelProps> = ({
  children,
  className,
  includeOptionalText,
  ...rest
}) => {
  return (
    <MuiFormLabel
      className={className}
      {...rest}
      sx={{
        ...(rest.sx ?? {}),
        color: rest.error ? colors.red[600] : colors.stone[950],
        fontWeight: 500,
        fontSize: fontSizes.sm,
        lineHeight: "20px",
        marginBottom: "0.5rem",
      }}
    >
      {children} {includeOptionalText && <span>(optional)</span>}
    </MuiFormLabel>
  );
};

export default FormLabel;
